export function getScreenSize(){
	return [window.innerWidth, window.innerHeight]
}